/* eslint-disable camelcase */
import useDevice from '@/hooks/useDevice';
import Icon from '@/components/UI/icon/Icon';
import styles from './Factor.module.scss';
import ConditionalRenderer from '@/components/reusable/ConditionalRenderer';
import { currencyHandler } from '@/helpers/currencyHandler';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Spinner from '@/components/UI/spinner/Spinner';
import { formatPersianDates } from '@/helpers/dateManager';
const titleHandler = data => {
  if (data.key === 'day') {
    return `${data.count} شب`;
  } else if (data.key === 'extra_person') {
    return `${data.count} نفر اضافه`;
  } else {
    return data.title;
  }
};
const Factor = ({
  checkin,
  checkout,
  proformaState,
  maxCheckin,
  minCheckout
}) => {
  const {
    isMobile
  } = useDevice();
  const data = proformaState?.data ? [...(proformaState.data?.days || []), ...(proformaState.data?.details || [])] : [];
  const convertDateTime = time => {
    const convertedTime = new Date(time * 1000);
    const comvertedDates = formatPersianDates(convertedTime, {
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    }).year.split(' ');
    return `${comvertedDates[0]} , ${comvertedDates[1]} ${comvertedDates[2]}`;
  };
  const totalPrice = proformaState?.data?.total_payable_amount;
  return <Box className={styles['factor-container']} data-sentry-element="Box" data-sentry-component="Factor" data-sentry-source-file="Factor.tsx">
      {isMobile && <Box className={styles['dates-container']}>
          <Box className={styles['dates-items']}>
            <Typography variant="bodyM_Bold">
              {`از ${!!checkin && convertDateTime(checkin)} `}
            </Typography>
            <Typography variant="bodyM">از {maxCheckin}</Typography>
          </Box>
          <Box>
            <Icon name="arrow-left" type="mediumEmphasis" />
          </Box>
          <Box className={styles['dates-items']}>
            <Typography variant="bodyM_Bold">
              {`تا ${!!checkout && convertDateTime(checkout)} `}
            </Typography>
            <Typography variant="bodyM">تا {minCheckout}</Typography>
          </Box>
        </Box>}
      <Box className={styles['factor-detail-container']} data-sentry-element="Box" data-sentry-source-file="Factor.tsx">
        {proformaState?.loading ? <Box className={styles['circular-progress']}>
            <Spinner color="primary_main" />
          </Box> : <Box className={styles['factor-detail-list']}>
            {data?.map((item, index) => item.final_price > 0 && item.count !== 0 && <Box className={styles['factor-detail-item']} key={'FACTOR_DETAIL_ITEM_' + index}>
                    <Box className={styles['row-title']}>
                      <Typography variant="bodyS">
                        {titleHandler(item)}
                      </Typography>
                      <ConditionalRenderer condition={item.key === 'day'}>
                        <>
                          <Typography variant="bodyS">x</Typography>
                          <Typography variant="bodyS">
                            {currencyHandler(item.unit_price)} تومان{' '}
                          </Typography>
                        </>
                      </ConditionalRenderer>
                    </Box>
                    <Typography variant="bodyS">
                      {currencyHandler(item?.final_price)}{' '}
                      <Typography variant="bodyS">تومان</Typography>
                    </Typography>
                  </Box>)}
          </Box>}
      </Box>
      <Box className={styles['factor-detail-final-price']} data-sentry-element="Box" data-sentry-source-file="Factor.tsx">
        <Typography variant="bodyM_Bold" className={styles['final-price-title']} data-sentry-element="Typography" data-sentry-source-file="Factor.tsx">
          مبلغ کل رزرو
        </Typography>
        <Typography variant="bodyM_Bold" className={styles['final-price-cost-value']} data-sentry-element="Typography" data-sentry-source-file="Factor.tsx">
          {currencyHandler(totalPrice?.final_price || 0)}{' '}
          <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="Factor.tsx">تومان</Typography>
        </Typography>
      </Box>
    </Box>;
};
export default Factor;